import { DatePickerProps } from '@mui/lab';
import { Size, Variant } from '.';

type VariantDict = {
  [key in Variant]: Partial<DatePickerProps<Date>>;
};

const deVariants: Record<Size, VariantDict> = {
  normal: {
    date: {
      inputFormat: 'dd.MM.y',
      mask: '__.__.____',
      toolbarFormat: 'eee, d. MMMM'
    },
    month: {
      inputFormat: 'MMMM y',
      mask: '____ ____',
      toolbarFormat: 'MMMM yyyy',
      views: ['month', 'year']
    },
    year: {
      inputFormat: 'y',
      mask: '____',
      toolbarFormat: 'yyyy',
      views: ['year']
    }
  },
  small: {
    date: {
      inputFormat: 'dd.MM.yy',
      mask: '__.__.__',
      toolbarFormat: 'eee, d. MMMM'
    },
    month: {
      inputFormat: 'MM/y',
      mask: '__ ____',
      toolbarFormat: 'MMMM yyyy',
      views: ['month', 'year']
    },
    year: {
      inputFormat: 'y',
      mask: '____',
      toolbarFormat: 'yyyy',
      views: ['year']
    }
  }
};

const enVariants: Record<Size, VariantDict> = {
  normal: {
    date: {
      inputFormat: 'MM/dd/y',
      mask: '__/__/____',
      toolbarFormat: 'eee, MMM d'
    },
    month: {
      inputFormat: 'MMMM y',
      mask: '____ ____',
      toolbarFormat: 'MMMM yyyy',
      views: ['month', 'year'],
      openTo: 'month'
    },
    year: {
      inputFormat: 'y',
      mask: '____',
      toolbarFormat: 'yyyy',
      views: ['year'],
      openTo: 'year'
    }
  },
  small: {
    date: {
      inputFormat: 'MM/dd/y',
      mask: '__/__/____',
      toolbarFormat: 'eee, MMM d'
    },
    month: {
      inputFormat: 'MMMM y',
      mask: '____ ____',
      toolbarFormat: 'MMMM yyyy',
      views: ['month', 'year'],
      openTo: 'month'
    },
    year: {
      inputFormat: 'y',
      mask: '____',
      toolbarFormat: 'yyyy',
      views: ['year'],
      openTo: 'year'
    }
  }
};

export const languageToFormat = (
  language: string,
  variant: Variant,
  size: Size
): Partial<DatePickerProps<Date>> => {
  if (language === 'de') {
    return deVariants[size][variant];
  }

  return enVariants[size][variant];
};
